module.exports = "<input type=\"text\" value=\"{{ thingToSlug }}\" class=\"form-control\" />\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/slug-input/slug-input.component.html
// module id = ./src/app/shared/slug-input/slug-input.component.html
// module chunks = main